import {
  PARTNER_WALL_CARD_SCHEMA_VERSION,
  CARD_VISIBILITY,
  CARD_MODERATION_STATUS,
  DEFAULT_WALL_ID,
} from "./cardConstants";
import {
  getCardLanguagePresentation,
  getFirstDistinctTranslationText,
} from "./languageAdaptiveCard";

export const getLanguageText = (card, languageCode) => {
  const languageContent = card?.languages?.[languageCode];

  if (typeof languageContent === "string") {
    return languageContent;
  }

  if (languageContent && typeof languageContent === "object") {
    return (
      languageContent.questionRefined ||
      languageContent.questionOriginal ||
      languageContent.question ||
      languageContent.text ||
      ""
    );
  }

  if (languageCode === "en") {
    return card?.questionRefined || card?.questionOriginal || "";
  }

  return "";
};

export const isPublicMCAADV1WallCard = (card, wallId = DEFAULT_WALL_ID) => (
  card?.schemaVersion === PARTNER_WALL_CARD_SCHEMA_VERSION &&
  Array.isArray(card.wallIds) &&
  card.wallIds.includes(wallId) &&
  card.visibility === CARD_VISIBILITY.PUBLIC &&
  card.moderationStatus === CARD_MODERATION_STATUS.APPROVED &&
  card.archivedAt === null
);

export const getFirstTranslationText = (
  translations,
  languageOptions = {}
) => getFirstDistinctTranslationText(translations, languageOptions);

export const normalizePublicWallCard = (card, wallId = DEFAULT_WALL_ID) => {
  if (!isPublicMCAADV1WallCard(card, wallId)) {
    return null;
  }

  const presentation = getCardLanguagePresentation({
    ...card,
    questionRefined: card.questionRefined || card.questionOriginal,
  });
  const question = presentation.question;

  if (!question) {
    return null;
  }

  return {
    id: card.id,
    question,
    translations: presentation.translations,
    translation: presentation.translation,
    language:
      presentation.translationLanguage ||
      presentation.translationLanguageCode ||
      "English",
    theme: card.themeId || "MCAAD",
    source: "firestore",
  };
};
